import React from "react";
import { CheckCircle2, XCircle, Calculator } from "lucide-react";
import { RichText } from "./RichText";

export const LETTERS = ["A", "B", "C", "D", "E"];

export default function QuestionCard({ q, number, chosen, onAnswer, testPrefix = "q" }) {
  const answered = chosen !== undefined && chosen !== null;
  const correct = answered && chosen === q.a;
  return (
    <div className={`q-card ${answered ? (correct ? "is-correct" : "is-wrong") : ""}`} data-testid={`${testPrefix}-card-${number}`}>
      <div className="q-top">
        <span className="q-num">Soru {number}</span>
        <span className={`badge ${q.s ? "badge-calc" : ""}`}>{q.s && <Calculator size={12} />} {q.t}</span>
      </div>
      <p className="q-text"><RichText text={q.q} /></p>
      <div className="q-options">
        {q.o.map((opt, i) => {
          let cls = "q-opt";
          if (answered) {
            if (i === q.a) cls += " opt-correct";
            else if (i === chosen) cls += " opt-wrong";
            else cls += " opt-dim";
          }
          return (
            <button
              key={i}
              className={cls}
              disabled={answered}
              onClick={() => onAnswer(i)}
              data-testid={`${testPrefix}-${number}-opt-${LETTERS[i]}`}
            >
              <span className="opt-letter">{LETTERS[i]}</span>
              <span className="opt-text"><RichText text={opt} /></span>
              {answered && i === q.a && <CheckCircle2 size={18} className="opt-ic" />}
              {answered && i === chosen && i !== q.a && <XCircle size={18} className="opt-ic" />}
            </button>
          );
        })}
      </div>

      {answered && (
        <div className={`feedback ${correct ? "fb-ok" : "fb-bad"}`} data-testid={`${testPrefix}-${number}-feedback`}>
          <div className="fb-title">
            {correct ? <><CheckCircle2 size={17} /> Doğru! Cevap {LETTERS[q.a]}</> : <><XCircle size={17} /> Yanlış — Senin cevabın {LETTERS[chosen]}, doğru cevap {LETTERS[q.a]}</>}
          </div>
          {!correct && (
            <div className="fb-why">
              <span className="fb-label">Seçtiğin şık neden yanlış?</span>
              <RichText text={(q.n && q.n[chosen]) || `"${q.o[chosen]}" ifadesi soru kökündeki koşulu karşılamıyor.`} />
            </div>
          )}
          <div className="fb-how">
            <span className="fb-label">{correct ? "Açıklama" : "Doğru cevap nasıl bulunur?"}</span>
            <RichText text={q.e} />
          </div>
          {q.s && (
            <ol className="fb-steps">
              {q.s.map((st, i) => <li key={i}><span className="step-n">{i + 1}</span><span>{st}</span></li>)}
            </ol>
          )}
        </div>
      )}
    </div>
  );
}
